import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { KEYS } from 'src/app/constants/keys';
import { RoutePath } from 'src/app/constants/routerPath';
import { CommonService } from 'src/app/services/common-service/common.service';
import { isPresent } from 'src/app/utils/utils';

@Component({
  selector: 'app-user-timesheet-status-dashboard',
  imports: [CommonModule],
  templateUrl: './user-timesheet-status-dashboard.component.html',
  styleUrls: ['./user-timesheet-status-dashboard.component.scss']
})
export class UserTimesheetStatusDashboardComponent implements OnInit {
  @Input() data: any;
  timesheetdata: any = [];
  constructor(public commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
    if (this.data) {
      this.commonService.ogLog('weekdata:', this.data);
      this.loaddata(this.data);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.commonService.ogLog('weekdata:', this.data);
    this.loaddata(this.data);
  }

  loaddata(weekid: any) {
    this.timesheetdata = []
    this.commonService.getdashboardTimesheetStatus(weekid, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((data: any) => {
      if (isPresent(data['table'])) {
        if (data['table'].length > 0) {
          let Data = [] = data['table'];
          this.timesheetdata = data;
          this.timesheetdata = this.timesheetdata['table'];
          this.commonService.ogLog('timesheetdata', this.timesheetdata)
        }

      }
    });
  }
  RowdataClick() {
    this.commonService.setDashbord(false);
    sessionStorage.setItem('moduleName', KEYS.hr_module);
    const pageDetails = {
      pageId: 264,
      pageName: 'Time Sheet',
      parentMenuId: 190,
      menuId: 202,
      withChildMenues: 0,
      withChildInnerPage: 0,
      isAddMode: false
    }
    this.commonService.ogLog('time SHeet', pageDetails);
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
  }

}
